import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTabloCompactStore } from "../../store";

interface ProtectedRouteProps {
  children?: ReactNode;
  redirectTo?: string;
}

const DEFAULT_REDIRECT = "/";

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  redirectTo = DEFAULT_REDIRECT,
}) => {
  const { carNumber, selectedOfficeId, selectedChassisType } =
    useTabloCompactStore();

  const isValid =
    carNumber !== "" &&
    selectedOfficeId !== null &&
    selectedChassisType !== null;

  if (!isValid) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
